export class ServicingCompaniesApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getServicingCompanies() {
    return this.#http.get('/ServicingCompanies');
  }

  async editServicingCompany({ id, ...body }) {
    return this.#http.put(`/ServicingCompanies/${id}`, body);
  }

  async createServicingCompany(body) {
    return this.#http.post('/ServicingCompanies', body);
  }

  async deleteServicingCompany({ id }) {
    return this.#http.delete(`/ServicingCompanies/${id}`);
  }
}
